import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/user/user9.jpg'


const _withScopeId = n => (_pushScopeId("data-v-57d9af97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-5 col-xl-12" }
const _hoisted_3 = { class: "col-xxl-8" }
const _hoisted_4 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "myTab",
  role: "tablist"
}
const _hoisted_7 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_8 = {
  class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active",
  id: "shipping-details-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#shipping-details-tab-pane",
  type: "button",
  role: "tab",
  "aria-controls": "shipping-details-tab-pane",
  "aria-selected": "true",
  ref: "tabStudent"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-student-with-graduation-cap" }, null, -1))
const _hoisted_10 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_11 = {
  class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
  id: "payment-method-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#payment-method-tab-pane",
  type: "button",
  role: "tab",
  "aria-controls": "payment-method-tab-pane",
  "aria-selected": "false",
  ref: "tabPayment"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-atm" }, null, -1))
const _hoisted_13 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit" }, null, -1))
const _hoisted_15 = {
  class: "tab-content p-15 p-sm-20 p-md-25 p-lg-30",
  id: "myTabContent"
}
const _hoisted_16 = {
  class: "tab-pane fade show active",
  id: "shipping-details-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Estudiante", -1))
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Año académico", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Sede", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Grupo asignado", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, " Fecha registro de admisión ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, " Lista de precio mensualidad ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Otros valores", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Descuento", -1))
const _hoisted_27 = { class: "d-sm-flex align-items-center justify-content-between" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-5 position-relative top-2" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow position-relative ms-5 top-2" }, null, -1))
const _hoisted_30 = {
  class: "tab-pane fade",
  id: "payment-method-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_31 = { class: "mb-15 mb-md-25 fw-bold text-black" }
const _hoisted_32 = {
  class: "accordion",
  id: "paymentAccordion"
}
const _hoisted_33 = { class: "accordion-item rounded-0" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "accordion-body p-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs-md-15 fs-lg-16 text-paragraph lh-base mb-0" }, " PSE Pagos seguros en línea... ")
], -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "accordion-item rounded-0" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "accordion-body p-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs-md-15 fs-lg-16 text-paragraph lh-base mb-0" }, " Por favor, al pagar en efectivo, reclame su recibo. ")
], -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 0,
  class: "text-danger mt-2 fs-md-15 fs-lg-16"
}
const _hoisted_42 = { class: "d-sm-flex align-items-center justify-content-between" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-5 position-relative top-2" }, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow position-relative ms-5 top-2" }, null, -1))
const _hoisted_45 = {
  class: "tab-pane fade",
  id: "place-order-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_46 = {
  key: 0,
  class: "mb-15 mb-md-25 fw-bold text-black"
}
const _hoisted_47 = { class: "box p-15 p-sm-20 p-md-25 mb-15 mb-md-25" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-sm-20 mb-md-25 d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-black-emphasis mb-0" }, "Detalle")
], -1))
const _hoisted_49 = { class: "inner-box p-15 p-sm-20 p-md-25 bg-white" }
const _hoisted_50 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_51 = { class: "text-paragraph fs-md-15 fs-lg-16 position-relative" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Estudiante", -1))
const _hoisted_53 = { class: "text-paragraph fs-md-15 fs-lg-16 position-relative" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Identificación ", -1))
const _hoisted_55 = { class: "text-paragraph fs-md-15 fs-lg-16 position-relative" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sede", -1))
const _hoisted_57 = { class: "text-paragraph fs-md-15 fs-lg-16 position-relative" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Grupo", -1))
const _hoisted_59 = { class: "text-paragraph fs-md-15 fs-lg-16 position-relative" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total", -1))
const _hoisted_61 = { class: "box p-15 p-sm-20 p-md-25" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-sm-20 mb-md-25 d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-black-emphasis mb-0" }, "Método de pago")
], -1))
const _hoisted_63 = { class: "d-flex align-items-center payment-method" }
const _hoisted_64 = { class: "title ms-15" }
const _hoisted_65 = { class: "d-block text-paragraph" }
const _hoisted_66 = { class: "mt-15 mt-sm-20 mt-md-25 d-sm-flex align-items-center justify-content-between" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-5 position-relative top-2" }, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow position-relative ms-5 top-2" }, null, -1))
const _hoisted_69 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_71 = { class: "col-xxl-4" }
const _hoisted_72 = { class: "card mb-25 border-0 rounded-0 bg-white order-summary-box letter-spacing" }
const _hoisted_73 = { class: "card-head bg-white d-flex align-items-center" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document text-info" }, null, -1))
const _hoisted_75 = { class: "mb-0 fw-bold text-black ms-10 ms-md-15" }
const _hoisted_76 = { class: "text-paragraph" }
const _hoisted_77 = { class: "card-body" }
const _hoisted_78 = { class: "table-responsive" }
const _hoisted_79 = { class: "table table-sm align-middle mb-0 summary-table" }
const _hoisted_80 = { class: "shadow-none fw-medium text-black product-title ps-0" }
const _hoisted_81 = {
  key: 0,
  src: _imports_0,
  class: "me-2 summary-img",
  alt: "product"
}
const _hoisted_82 = { class: "summary-title" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-qty text-muted" }, "x1", -1))
const _hoisted_84 = { class: "shadow-none fw-medium text-paragraph text-end pe-0 summary-amount" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-muted ps-0",
  colspan: "2"
}, "Seleccione una lista de precio para ver el resumen.", -1))
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = { class: "order-summary-list ps-0 mb-0 list-unstyled" }
const _hoisted_89 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-paragraph fw-medium" }, "Subtotal (Incluido IVA)", -1))
const _hoisted_91 = { class: "d-block text-black fs-md-15 fs-lg-16 fw-medium" }
const _hoisted_92 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-paragraph fw-medium" }, "Descuento", -1))
const _hoisted_94 = { class: "d-block text-black fs-md-15 fs-lg-16 fw-medium" }
const _hoisted_95 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-paragraph fw-medium" }, "Total", -1))
const _hoisted_97 = { class: "d-block text-primary fs-md-15 fs-lg-16 fw-bold" }
const _hoisted_98 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-paragraph fw-medium" }, "Estado admisión", -1))
const _hoisted_100 = { class: "badge text-outline-success" }
const _hoisted_101 = {
  key: 0,
  class: "card-body"
}
const _hoisted_102 = { class: "docs-box mb-15" }
const _hoisted_103 = { class: "d-flex align-items-center justify-content-between mb-10" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-black" }, "Documentos", -1))
const _hoisted_105 = {
  key: 0,
  class: "badge bg-light text-muted"
}
const _hoisted_106 = { class: "docs-grid" }
const _hoisted_107 = ["disabled"]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "CONFIRMED_ENROLLMENT" }, "Confirmación de matrícula", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "GOVERNMENT_CONFIRMATION" }, "Confirmación matrícula (Gobierno)", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ENROLLMENT_CERTIFICATION" }, "Certificación de matrícula", -1))
const _hoisted_111 = [
  _hoisted_108,
  _hoisted_109,
  _hoisted_110
]
const _hoisted_112 = { key: 0 }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-printer me-1" }, null, -1))
const _hoisted_114 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "docs-hint mt-10" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-info me-1" }),
  /*#__PURE__*/_createTextVNode(" Selecciona el documento y presiona imprimir (se abre en una nueva pestaña). ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_MultiSearchSelect = _resolveComponent("MultiSearchSelect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.toNum(_ctx.form.record.Id) > 0)
        ? (_openBlock(), _createBlock(_component_BreadCrumb, {
            key: 0,
            PageTitle: `Matrícula ${_ctx.form.record.SequenceId || ''}`
          }, null, 8, ["PageTitle"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("button", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" DATOS ESTUDIANTE ")
              ], 512)
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("button", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(" MÉTODO DE PAGO ")
              ], 512)
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_b_button, {
                class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
                id: "place-order-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#place-order-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "place-order-tab-pane",
                "aria-selected": "false",
                ref: "tabConfirm"
              }, {
                default: _withCtx(() => [
                  _hoisted_14,
                  _createTextVNode(" " + _toDisplayString(_ctx.disabledRecord ? 'RESUMEN ADMISIÓN' : 'REGISTRAR ADMISIÓN'), 1)
                ]),
                _: 1
              }, 512)
            ])
          ]),
          _createVNode(_component_b_form, {
            ref: "formRecord",
            id: "formModal",
            onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_17,
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_SearchSelect, {
                                    modelValue: _ctx.form.record.StudentId,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.StudentId) = $event)),
                                    required: "",
                                    "was-validated": _ctx.form.wasValidated,
                                    onChange: _ctx.changeValuesLoad,
                                    disabled: _ctx.disabledRecord,
                                    loading: _ctx.form.loading,
                                    options: _ctx.students.map(r => ({ value: _ctx.toNum(r.Id), text: `${r.IdentificationNumber} - ${r.Name} ${r.LastName}` })),
                                    placeholder: "Seleccione el estudiante"
                                  }, null, 8, ["modelValue", "was-validated", "onChange", "disabled", "loading", "options"])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_20,
                              _createVNode(_component_SearchSelect, {
                                modelValue: _ctx.form.record.AcademicYearId,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.AcademicYearId) = $event)),
                                required: "",
                                "was-validated": _ctx.form.wasValidated,
                                loading: _ctx.form.loading,
                                disabled: _ctx.disabledRecord,
                                options: _ctx.academicYears.map(r => ({ value: _ctx.toNum(r.Id), text: `Año ${r.Year} - Período: ${r.StartDate.substring(0, 10)} Hasta ${r.EndDate.substring(0, 10)}` })),
                                placeholder: "Seleccione el año académico",
                                onChange: _ctx.changeValuesLoad
                              }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_21,
                              _createVNode(_component_SearchSelect, {
                                modelValue: _ctx.form.record.HeadquarterId,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.HeadquarterId) = $event)),
                                required: "",
                                "was-validated": _ctx.form.wasValidated,
                                loading: _ctx.form.loading,
                                disabled: _ctx.disabledRecord,
                                options: _ctx.headquarters.map(r => ({ value: _ctx.toNum(r.Id), text: `${r.Description}` })),
                                placeholder: "Seleccione la sede",
                                onChange: _ctx.changeValuesLoad
                              }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_22,
                              _createVNode(_component_SearchSelect, {
                                modelValue: _ctx.form.record.CourseGroupId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.CourseGroupId) = $event)),
                                required: "",
                                "was-validated": _ctx.form.wasValidated,
                                loading: _ctx.form.loading,
                                disabled: _ctx.disabledRecord,
                                options: _ctx.coursesGroupAvailable.map(r => ({ value: _ctx.toNum(r.Id), text: r.Name })),
                                placeholder: "Seleccione el grupo"
                              }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_23,
                              _createVNode(_component_b_form_input, {
                                id: "input-enrollment-date",
                                disabled: _ctx.disabledRecord,
                                class: "form-control fs-14 text-black shadow-none form-control-sm",
                                modelValue: _ctx.form.record.EnrollmentDate,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.EnrollmentDate) = $event)),
                                type: "date",
                                required: ""
                              }, null, 8, ["disabled", "modelValue"]),
                              _createVNode(_component_b_form_invalid_feedback, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Campo requerido")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_24,
                              _createVNode(_component_SearchSelect, {
                                modelValue: _ctx.form.record.TuitionPriceLineId,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record.TuitionPriceLineId) = $event)),
                                required: "",
                                "was-validated": _ctx.form.wasValidated,
                                loading: _ctx.form.loading,
                                disabled: _ctx.disabledRecord,
                                options: _ctx.priceLineFiltered
                          .filter(r => _ctx.getPriceListById(r.PriceListId)?.Type === 'MENSUALIDAD')
                          .map(r => ({ value: _ctx.toNum(r.Id), text: `${_ctx.getPriceListById(r.PriceListId)?.Name || ''} - ${r.Concept || ''} - $ ${r.Amount || '0.00'} ${_ctx.priceListRecord.Currency || ''}` })),
                                placeholder: "Seleccione el valor de la lista",
                                onChange: _ctx.changeValuesLoad
                              }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_25,
                              _createVNode(_component_MultiSearchSelect, {
                                modelValue: _ctx.form.record.TuitionPriceLineIdOthersList,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.record.TuitionPriceLineIdOthersList) = $event)),
                                "was-validated": _ctx.form.wasValidated,
                                loading: _ctx.form.loading,
                                disabled: _ctx.disabledRecord,
                                options: _ctx.priceLineFiltered
                          .filter(r => _ctx.getPriceListById(r.PriceListId)?.Type === 'OTROS')
                          .map(r => ({
                            value: _ctx.toNum(r.Id),
                            text: `${_ctx.getPriceListById(r.PriceListId)?.Name || ''} - ${r.Concept || ''} - $ ${r.Amount || '0.00'} ${_ctx.priceListRecord.Currency || ''}`
                          })),
                                placeholder: "Seleccione valores de la lista",
                                onChange: _ctx.changeValuesLoad
                              }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_26,
                              _createVNode(_component_SearchSelect, {
                                modelValue: _ctx.form.record.DiscountId,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.record.DiscountId) = $event)),
                                "was-validated": _ctx.form.wasValidated,
                                loading: _ctx.form.loading,
                                disabled: _ctx.disabledRecord,
                                options: _ctx.discounts.map(r => ({ value: _ctx.toNum(r.Id), text: `${r.Description}` })),
                                placeholder: "Seleccione el descuento (Si aplica)",
                                onChange: _ctx.changeValuesLoad
                              }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_router_link, {
                      to: "/cart",
                      class: "d-inline-block mb-12 mb-sm-0 fs-14 fs-md-15 fs-lg-16 fw-medium text-decoration-none"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28,
                        _createTextVNode(" Cancelar ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_button, {
                      class: "default-btn transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Siguiente "),
                        _hoisted_29
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("h5", _hoisted_31, _toDisplayString(_ctx.disabledRecord ? 'Método de pago registrado' : 'Seleccione el método de pago'), 1),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_b_button, {
                        class: _normalizeClass([
                      'accordion-button text-black fs-14 fs-md-15 fs-lg-16 fw-semibold shadow-none border-0 rounded-0 bg-white d-flex align-items-center justify-content-between',
                      _ctx.form.record.MethodOfPayment === 'TRANSFERENCIA' ? '' : 'collapsed'
                    ]),
                        type: "button",
                        "aria-pressed": _ctx.form.record.MethodOfPayment === 'TRANSFERENCIA' ? 'true' : 'false',
                        disabled: _ctx.disabledRecord,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setPayment('TRANSFERENCIA')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_34,
                          _createTextVNode(" TRANSFERENCIA ELECTRÓNICA / PSE ")
                        ]),
                        _: 1
                      }, 8, ["class", "aria-pressed", "disabled"]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["accordion-collapse", _ctx.form.record.MethodOfPayment === 'TRANSFERENCIA' ? 'show' : ''])
                      }, _hoisted_36, 2)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_b_button, {
                        class: _normalizeClass([
                      'accordion-button text-black fs-14 fs-md-15 fs-lg-16 fw-semibold shadow-none border-0 rounded-0 bg-white d-flex align-items-center justify-content-between',
                      _ctx.form.record.MethodOfPayment === 'EFECTIVO' ? '' : 'collapsed'
                    ]),
                        disabled: _ctx.disabledRecord,
                        type: "button",
                        "aria-pressed": _ctx.form.record.MethodOfPayment === 'EFECTIVO' ? 'true' : 'false',
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setPayment('EFECTIVO')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_38,
                          _createTextVNode(" EFECTIVO ")
                        ]),
                        _: 1
                      }, 8, ["class", "disabled", "aria-pressed"]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["accordion-collapse", _ctx.form.record.MethodOfPayment === 'EFECTIVO' ? 'show' : ''])
                      }, _hoisted_40, 2)
                    ])
                  ]),
                  (_ctx.paymentError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.paymentError), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.goTo('tabStudent')), ["prevent"])),
                      class: "d-inline-block mb-12 mb-sm-0 fs-14 fs-md-15 fs-lg-16 fw-medium text-decoration-none"
                    }, [
                      _hoisted_43,
                      _createTextVNode(" Anterior ")
                    ]),
                    _createVNode(_component_b_button, {
                      class: "default-btn transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                      type: "button",
                      onClick: _ctx.handleNextFromPayment
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Siguiente "),
                        _hoisted_44
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  (!_ctx.disabledRecord)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_46, " Confirmar admisión "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("ul", _hoisted_50, [
                        _createElementVNode("li", _hoisted_51, [
                          _hoisted_52,
                          _createTextVNode(" " + _toDisplayString(`   ${_ctx.studentRecord?.Name || ''} ${_ctx.studentRecord?.LastName || ''}`), 1)
                        ]),
                        _createElementVNode("li", _hoisted_53, [
                          _hoisted_54,
                          _createTextVNode(" " + _toDisplayString(`   ${_ctx.studentRecord?.IdentificationNumber || ''}`), 1)
                        ]),
                        _createElementVNode("li", _hoisted_55, [
                          _hoisted_56,
                          _createTextVNode(" " + _toDisplayString(`   ${_ctx.headquarters.find(h => _ctx.toNum(h.Id) ===
                          _ctx.toNum(_ctx.form.record?.HeadquarterId))?.Description || ''}`), 1)
                        ]),
                        _createElementVNode("li", _hoisted_57, [
                          _hoisted_58,
                          _createTextVNode(" " + _toDisplayString(`   ${_ctx.coursesGroup.find(cg => _ctx.toNum(cg.Id) === _ctx.toNum(_ctx.form.record?.CourseGroupId))?.Name
                          || ''}`), 1)
                        ]),
                        _createElementVNode("li", _hoisted_59, [
                          _hoisted_60,
                          _createTextVNode(" " + _toDisplayString(`   $ ${_ctx.formatMoney(_ctx.total)} ${_ctx.currency}`), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.form.record.MethodOfPayment || 'No encontrado'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.goTo('tabPayment')), ["prevent"])),
                      class: "d-inline-block mb-12 mb-sm-0 fs-14 fs-md-15 fs-lg-16 fw-medium text-decoration-none"
                    }, [
                      _hoisted_67,
                      _createTextVNode(" Anterior ")
                    ]),
                    (!_ctx.disabledRecord)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "default-btn transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                          type: "button",
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.registerAdmission && _ctx.registerAdmission(...args)))
                        }, [
                          _createTextVNode(" REGISTRAR ADMISIÓN "),
                          _hoisted_68,
                          (_ctx.form.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                                _hoisted_70,
                                _createTextVNode(" Cargando... ")
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_71, [
      _createElementVNode("div", _hoisted_72, [
        _createElementVNode("div", _hoisted_73, [
          _hoisted_74,
          _createElementVNode("h5", _hoisted_75, [
            _createTextVNode(" Resumen admisión "),
            _createElementVNode("span", _hoisted_76, " (" + _toDisplayString(_ctx.summaryLines.length) + " Item" + _toDisplayString(_ctx.summaryLines.length === 1 ? '' : 's') + ") ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_77, [
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("table", _hoisted_79, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryLines, (ln, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `${ln.Id}-${idx}`
                  }, [
                    _createElementVNode("td", _hoisted_80, [
                      _createVNode(_component_router_link, {
                        to: "#",
                        class: "d-flex align-items-start text-decoration-none text-black summary-link"
                      }, {
                        default: _withCtx(() => [
                          (idx === 0)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_81))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_82, [
                            _createTextVNode(_toDisplayString(ln.Title) + " ", 1),
                            _hoisted_83
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("td", _hoisted_84, " $ " + _toDisplayString(`${_ctx.formatMoney(ln.Amount)} ${_ctx.currency}`), 1)
                  ]))
                }), 128)),
                (!_ctx.summaryLines.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_85, _hoisted_87))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("ul", _hoisted_88, [
            _createElementVNode("li", _hoisted_89, [
              _hoisted_90,
              _createElementVNode("span", _hoisted_91, " $ " + _toDisplayString(`${_ctx.formatMoney(_ctx.subtotal)} ${_ctx.currency}`), 1)
            ]),
            _createElementVNode("li", _hoisted_92, [
              _hoisted_93,
              _createElementVNode("span", _hoisted_94, " - " + _toDisplayString(_ctx.formatMoney(_ctx.discountAmount)) + " (" + _toDisplayString(_ctx.discountPercent) + "%) ", 1)
            ]),
            _createElementVNode("li", _hoisted_95, [
              _hoisted_96,
              _createElementVNode("span", _hoisted_97, " $ " + _toDisplayString(`${_ctx.formatMoney(_ctx.total)} ${_ctx.currency}`), 1)
            ]),
            (_ctx.disabledRecord)
              ? (_openBlock(), _createElementBlock("li", _hoisted_98, [
                  _hoisted_99,
                  _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.form.record?.Status), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.canPrint)
          ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("div", _hoisted_103, [
                  _hoisted_104,
                  (!_ctx.canPrint)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_105, " Guarde para imprimir "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-select-sm shadow-none docs-select",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedReport) = $event)),
                    disabled: !_ctx.canPrint || _ctx.printing
                  }, _hoisted_111, 8, _hoisted_107), [
                    [_vModelSelect, _ctx.selectedReport]
                  ]),
                  _createVNode(_component_b_button, {
                    class: "docs-btn-print",
                    disabled: !_ctx.canPrint || _ctx.printing,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.printReport(_ctx.selectedReport)))
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.printing)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_112, [
                            _hoisted_113,
                            _createTextVNode(" Imprimir ")
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_114, [
                            _hoisted_115,
                            _createTextVNode(" Imprimiendo... ")
                          ]))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _hoisted_116
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}